/** Deep-link actions from Knowledge Base create/add articles onto existing pages. */

export type KnowledgeBaseAction = {
  path: string;
  /** When true, target page should spotlight the add button (no auto-open dialog). */
  showAddHint?: boolean;
  /** When true, create page should show section coachmarks. */
  showSectionHints?: boolean;
  /** When true, fleet table should spotlight row edit/delete actions. */
  showRowActionsHint?: boolean;
  /** When true, drivers table should spotlight the view (eye) action. */
  showDriverViewHint?: boolean;
  /** When true, drivers table should spotlight edit + assign actions. */
  showDriverEditAssignHint?: boolean;
  /** When true, containers map should spotlight the QR action. */
  showQrHint?: boolean;
  /** When true, pickup orders page should spotlight the date filter. */
  showDateFilterHint?: boolean;
  /** When true, pickup orders page should spotlight the status filter. */
  showStatusHint?: boolean;
  /** When true, pickup orders page should spotlight the orders table. */
  showTableHint?: boolean;
  labelKey: string;
};

const KNOWLEDGE_BASE_ACTIONS: Record<string, KnowledgeBaseAction> = {
  'add-material-type': {
    path: '/recycling/materials',
    showAddHint: true,
    labelKey: 'knowledgeBase.actions.addMaterialType',
  },
  'edit-material-type': {
    path: '/recycling/materials',
    showRowActionsHint: true,
    labelKey: 'knowledgeBase.actions.editOrDeleteMaterial',
  },
  'add-collection-site': {
    path: '/containers/sites',
    showAddHint: true,
    labelKey: 'knowledgeBase.actions.addCollectionSite',
  },
  'edit-or-delete-collection-site': {
    path: '/containers/sites',
    showRowActionsHint: true,
    labelKey: 'knowledgeBase.actions.editOrDeleteCollectionSite',
  },
  'add-container': {
    path: '/containers/list',
    showAddHint: true,
    labelKey: 'knowledgeBase.actions.addContainer',
  },
  'edit-or-delete-container': {
    path: '/containers/list',
    showRowActionsHint: true,
    labelKey: 'knowledgeBase.actions.editOrDeleteContainer',
  },
  'print-container-qr': {
    path: '/containers/list',
    showQrHint: true,
    labelKey: 'knowledgeBase.actions.printContainerQr',
  },
  'create-pickup-order-outlet': {
    path: '/pickup_orders/create',
    showSectionHints: true,
    labelKey: 'knowledgeBase.actions.createPickupOrder',
  },
  'view-pickup-orders-list': {
    path: '/pickup_orders',
    showTableHint: true,
    labelKey: 'knowledgeBase.actions.viewPickupOrdersList',
  },
  'filter-pickup-orders-by-date': {
    path: '/pickup_orders',
    showDateFilterHint: true,
    labelKey: 'knowledgeBase.actions.filterPickupByDate',
  },
  'pickup-order-statuses': {
    path: '/pickup_orders',
    showStatusHint: true,
    labelKey: 'knowledgeBase.actions.pickupOrderStatuses',
  },
  'add-vehicle': {
    path: '/transportation/fleet',
    showAddHint: true,
    labelKey: 'knowledgeBase.actions.addVehicle',
  },
  'edit-or-delete-vehicle': {
    path: '/transportation/fleet',
    showRowActionsHint: true,
    labelKey: 'knowledgeBase.actions.editOrDeleteVehicle',
  },
  'add-driver': {
    path: '/transportation/drivers',
    showAddHint: true,
    labelKey: 'knowledgeBase.actions.addDriver',
  },
  'view-driver-details': {
    path: '/transportation/drivers',
    showDriverViewHint: true,
    labelKey: 'knowledgeBase.actions.viewDriverDetails',
  },
  'edit-or-delete-driver': {
    path: '/transportation/drivers',
    showDriverEditAssignHint: true,
    labelKey: 'knowledgeBase.actions.editOrAssignDriver',
  },
};

export function getKnowledgeBaseAction(articleId: string): KnowledgeBaseAction | undefined {
  return KNOWLEDGE_BASE_ACTIONS[articleId];
}
